// src/i18n/en/hmiSimulator.js
const hmiSimulator = {
    name: 'HMI Simulator',
    messages: {
        device_provisioned_successfully: 'Device provisioned successfully',
    },
};

export default hmiSimulator;
